@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/spacing.module.less';

.input-additional-info {
  font-weight: 400;
  margin-left: @space-4;
  color: var(--default--disabled--text-color--4);
}

.template-name-label {
  display: block;
  text-align: left;
}

.input-container {
  // looks weird but we try to match it to the first column
  width: 25.5%;
  min-width: 200px;
  margin-top: @space-4;
  margin-bottom: @space-16;
}

.error {
  font-size: 12px;
  padding: @space-4;
  background-color: var(--red-100);
}
